import pinterestKeywordHtmlUrl from './views/pinterestKeyword.html';

let app = angular.module('app.pinterestKeyword.component', []);

app.component('pinterestKeyword', {
    bindings: {
        selectedPinterestKeyword: '=',
        clusterId: '<',
        clientId: '<',
        isEditForm: '<',
        showActions: '<'
    },
    templateUrl: pinterestKeywordHtmlUrl,

    controller: function () {
        let self = this;

        self.$onInit = function () {
            // Parse selectedPinterestKeyword if passed as string
            if (typeof self.selectedPinterestKeyword === 'string') {
                try {
                    self.selectedPinterestKeyword = JSON.parse(self.selectedPinterestKeyword);
                } catch (e) {
                    console.error('Error parsing selectedPinterestKeyword:', e);
                    self.selectedPinterestKeyword = [];
                }
            }

            // Ensure selectedPinterestKeyword is an array
            if (!Array.isArray(self.selectedPinterestKeyword)) {
                self.selectedPinterestKeyword = [];
            }

            // Set edit mode: showActions input controls this (true by default)
            self.isFormEdit = (self.showActions !== false);

            // Initialize newKeyword for inputs
            self.newKeyword = {
                match_type: '',
                value: ''
            };
        };

        self.matchTypes = [
            'BROAD',
            'PHRASE',
            'EXACT',
            'EXACT_NEGATIVE',
            'PHRASE_NEGATIVE'
        ];

        self.addKeyword = function () {
            if (
                self.newKeyword.match_type &&
                self.newKeyword.value &&
                self.newKeyword.value.trim().length > 0
            ) {
                const trimmedValue = self.newKeyword.value.trim();

                const exists = self.selectedPinterestKeyword.some(k =>
                    k.match_type === self.newKeyword.match_type &&
                    k.value.toLowerCase() === trimmedValue.toLowerCase()
                );

                if (!exists) {
                    self.selectedPinterestKeyword.push({
                        match_type: self.newKeyword.match_type,
                        value: trimmedValue
                    });
                }

                self.newKeyword.match_type = '';
                self.newKeyword.value = '';
            }
        };

        self.removeKeyword = function (index) {
            self.selectedPinterestKeyword.splice(index, 1);
        };
    }
});
